// import moment from "moment"
// import _ from "lodash"

export default {
    computed: {
        dataBelongsTo(){
            if(this.$store.state.user.role && this.$store.state.user.role == 'pit'){
                return this.$store.state.dataBelongsTo
            } else {
                return false
            }
        },

        dateRange() {
            return this.$store.state.dateRange
        }
    },

    methods: {
        getSearchParams(){
            return new Promise((resolve) => {
                if(!_.isNull(this.searchParams) && this.searchParams){
                    let searchParams = this.searchParams.split('&')

                    if(searchParams.length > 1){
                        searchParams = searchParams[1].split('.')
                        this.sortOrder = searchParams[1]
                    }

                    this.sortField = searchParams[0].replace('sort_by=', '')

                    resolve()
                } else {
                    resolve()
                }
            })
        },

        setParams(searchParams, type, useDataBelongsTo = true){
            if(!type){ console.error('setParams called but type is not defined!'); return false };
            let params = []

            if(searchParams){
                // Only once if searchparams are stored in Vuex.state.searchParams
                params = searchParams
                this.$store.dispatch('setSearchQuery', {type, query: null}) // Unset after use
            } else {
                if(this.perPage) params.push(`paginate=${this.perPage}`)
                if(this.sortField && this.sortOrder) params.push(`sort_by=${this.sortField}.${this.sortOrder}`)
                if(this.page) params.push(`page=${this.page}`)
            }

            if(this.dataBelongsTo && useDataBelongsTo){
                if(typeof(params) == 'object'){
                    params.push(`organisation=${this.dataBelongsTo}`)
                } else {
                    // Replace organisation id to be sure -- because it can be changed in an other view.
                    const orgIndex = _.filter(params.split('&'), function( s ) { return s.indexOf( 'organisation' ) !== -1; });
                    params = params.replace(orgIndex[0], `organisation=${this.dataBelongsTo}`)
                }
            }

            if(_.has(this, 'showCancelledOrders') && this.showCancelledOrders){
                params.push(`cancelled=1`)
            }
            if(_.has(this, 'showPaidOrders') && !this.showPaidOrders && (type && ['InvoicesOverview-recent', 'InvoicesOverview-los', 'CreditInvoiceOverview'].includes(type))){
                params.push(`hidepaid=1`)
            }

            if(typeof(params) == 'string'){ params = params.split('&') }

            if(_.has(this.$route.meta, 'dateRangeFilter') && !_.isNull(this.$store.state.dateRange)){
                params.push(`fromDate=${moment(this.$store.state.dateRange[0]).format('YYYY-MM-DD')}`)
                params.push(`toDate=${moment(this.$store.state.dateRange[1]).format('YYYY-MM-DD')}`)
            }

            if(typeof(params) == 'object'){
                params = params.join('&')
            }

            // console.log(`SetParams @ ${type}`, params)
            return params
        }
    },

    watch: {
        dataBelongsTo: function(newVal){
            // console.log('dataBelongsTo changed!', newVal)
            this.loadAsyncData()
        },

        dateRange(){
            this.loadAsyncData()
        }
    }
}